import styled, { css } from 'styled-components'
import Img from '../../../shared/Image'

export const AnimationStepContainer = styled.div`
  overflow: hidden;
  max-width: 54rem;
  margin: 0 auto 6.4rem;
  padding: 0 2rem;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    padding: 0;

    &:last-child {
      margin-bottom: 12rem;
    }
  }


`

export const Description = styled.div`
  text-align: center;
  margin: 3.2rem auto 0;
`

export const AnimatedImage = styled(Img)`
  max-width: initial;
  width: auto;
  right: auto;
  position: relative;
  margin: auto;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;

  ${props => props.animationOver && css`
    left: -${props => props.length - 540}px;
  `}
`

export const MobileImage = styled(Img)`
  display: block;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    display: none;
  }
`
